(() => {
  const scrollLock = (() => {
    let count = 0;
    let scrollY = 0;
    return {
      acquire() {
        if (count++ > 0) return;
        scrollY = window.scrollY || window.pageYOffset || 0;
        const sb = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        document.documentElement.style.setProperty('--n5x-sb', sb + 'px');
        document.documentElement.classList.add('n5x-scroll-locked');
        document.body.style.top = '-' + scrollY + 'px';
        document.body.dataset.n5xScrollY = String(scrollY);
      },
      release() {
        if (count === 0) return;
        if (--count > 0) return;
        document.documentElement.classList.remove('n5x-scroll-locked');
        document.documentElement.style.removeProperty('--n5x-sb');
        const y = Number(document.body.dataset.n5xScrollY || scrollY || 0);
        document.body.style.top = '';
        delete document.body.dataset.n5xScrollY;
        window.scrollTo(0, y);
      }
    };
  })();

  window.n5xScrollLock = scrollLock;

  const setup = (rootEl = document) => {
    rootEl.querySelectorAll('desktop-navigation').forEach(nav => {
      if (nav.dataset.n5xKeyboard) return;
      nav.dataset.n5xKeyboard = 'true';
      const timers = new Map();
      let menuLocked = false;
      const entries = [...nav.querySelectorAll('.has-dropdown')].map(parent => {
        const trigger = parent.querySelector('[aria-controls]');
        const panel = trigger && document.getElementById(trigger.getAttribute('aria-controls'));
        return { parent, trigger, panel };
      }).filter(entry => entry.panel);
      const cancel = entry => { clearTimeout(timers.get(entry)); timers.delete(entry); };
      const syncScrollLock = () => {
        const anyOpen = entries.some(entry => entry.trigger.getAttribute('aria-expanded') === 'true');
        if (anyOpen && !menuLocked) {
          menuLocked = true;
          scrollLock.acquire();
        } else if (!anyOpen && menuLocked) {
          menuLocked = false;
          scrollLock.release();
        }
      };
      const hide = entry => {
        cancel(entry);
        entry.trigger.setAttribute('aria-expanded', 'false');
        entry.panel.setAttribute('hidden', '');
        entry.panel.classList.remove('is-closing');
        nav.dispatchEvent(new CustomEvent('desktop-nav:dropdown:close', { bubbles: true }));
        requestAnimationFrame(syncScrollLock);
      };
      nav.openDropdown = parent => {
        const entry = entries.find(item => item.parent === parent);
        if (!entry) return;
        cancel(entry);
        entries.forEach(other => {
          if (other !== entry && !other.parent.contains(parent) && other.trigger.getAttribute('aria-expanded') === 'true') hide(other);
        });
        entry.panel.classList.remove('is-closing');
        entry.panel.removeAttribute('hidden');
        entry.trigger.setAttribute('aria-expanded', 'true');
        entry.panel.querySelectorAll('.mega-menu__column, .mega-menu__image-push').forEach(item => {
          item.getAnimations().forEach(animation => animation.cancel());
          item.style.opacity = '1';
          item.style.transform = 'none';
        });
        nav.currentMegaMenu = entry.panel;
        nav.dispatchEvent(new CustomEvent('desktop-nav:dropdown:open', { bubbles: true }));
        syncScrollLock();
      };
      nav.closeDropdown = parent => {
        const entry = entries.find(item => item.parent === parent);
        if (!entry) return;
        cancel(entry);
        timers.set(entry, setTimeout(() => {
          if (!entry.parent.matches(':hover') && !entry.panel.matches(':hover')) hide(entry);
        }, 250));
      };
      const touchLike = () => window.matchMedia('(hover: none), (pointer: coarse)').matches;
      entries.forEach(entry => {
        if (entry.panel.querySelector('.mega-menu__brands')) {
          const close = document.createElement('button');
          close.type = 'button';
          close.className = 'n5x-menu-close';
          close.textContent = 'Close brands ×';
          close.addEventListener('click', () => {
            entry.trigger.focus();
            hide(entry);
          });
          entry.panel.prepend(close);
        }
        [entry.parent, entry.panel].forEach(target => {
          target.addEventListener('mouseenter', () => cancel(entry));
          target.addEventListener('mouseleave', () => nav.closeDropdown(entry.parent));
        });
        entry.trigger.addEventListener('focus', () => {
          if (!touchLike()) nav.openDropdown(entry.parent);
        });
        entry.trigger.addEventListener('click', event => {
          const href = entry.trigger.getAttribute('href');
          const menuOnly = entry.trigger.tagName === 'BUTTON' || href === '#';
          const alreadyOpen = entry.trigger.getAttribute('aria-expanded') === 'true';
          if (menuOnly) {
            event.preventDefault();
            nav.openDropdown(entry.parent);
            return;
          }
          if (touchLike() && !alreadyOpen) {
            event.preventDefault();
            event.stopPropagation();
            nav.openDropdown(entry.parent);
          }
        });
      });
      nav.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const entry = entries.find(item => item.trigger.getAttribute('aria-expanded') === 'true');
        if (entry) { entry.trigger.focus(); entries.forEach(hide); event.preventDefault(); }
      });
      nav.addEventListener('focusout', event => {
        if (!nav.contains(event.relatedTarget)) entries.forEach(entry => nav.closeDropdown(entry.parent));
      });
      document.addEventListener('pointerdown', event => {
        if (!nav.contains(event.target)) entries.forEach(hide);
      });
      nav.addEventListener('desktop-nav:dropdown:open', syncScrollLock);
      nav.addEventListener('desktop-nav:dropdown:close', () => requestAnimationFrame(syncScrollLock));
    });
  };
  customElements.whenDefined('desktop-navigation').then(() => setup());
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
